import { Text, TextProps } from "@chakra-ui/react";

const WhiteText = (props: TextProps) => {
  return <Text {...props} color="white" />;
};

export default WhiteText;
